import { Button, Card, Descriptions, Form, Input, Space, Table, Typography, message } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { IUserRoleExpiryResponse } from "../../constant/type";
import { lookupRoleExpiration } from "../../services";

const { Title, Text } = Typography;

const RoleLookup = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<IUserRoleExpiryResponse | null>(null);

  const onFinish = async (values: any) => {
    const provided = [values.id, values.phone_number, values.email].filter((v) => v);
    if (provided.length === 0) {
      message.warning("Vui lòng nhập ít nhất một trường");
      return;
    }
    if (provided.length > 1) {
      message.warning("Chỉ được nhập 1 trong các trường: User ID / Số điện thoại / Email");
      return;
    }
    setLoading(true);
    try {
      const response = await lookupRoleExpiration({
        id: values.id,
        phone_number: values.phone_number?.trim(),
        email: values.email?.trim(),
      });
      setData(response.data);
    } catch (error: any) {
      setData(null);
      message.error("Không tìm thấy thông tin role");
    } finally {
      setLoading(false);
    }
  };

  const columns = [
    {
      title: "Role ID",
      dataIndex: "role_id",
      key: "role_id",
    },
    {
      title: "Hết hạn",
      dataIndex: "expired_date",
      key: "expired_date",
      render: (value: number | null) =>
        value ? dayjs.unix(Number(value)).format("DD/MM/YYYY HH:mm") : "Không thiết lập",
    },
    {
      title: "Tạo lúc",
      dataIndex: "created_at",
      key: "created_at",
      render: (value: number | null) =>
        value ? dayjs.unix(Number(value)).format("DD/MM/YYYY HH:mm") : "-",
    },
    {
      title: "Cập nhật",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (value: number | null) =>
        value ? dayjs.unix(Number(value)).format("DD/MM/YYYY HH:mm") : "-",
    },
  ];

  return (
    <div className="p-4 space-y-4">
      <Card>
        <Title level={4}>Tra cứu thời hạn role</Title>
        <Form layout="vertical" form={form} onFinish={onFinish}>
          <Space direction="vertical" size="middle" className="w-full">
            <Space size="middle" className="w-full" wrap>
              <Form.Item name="id" label="User ID" className="w-60" tooltip="Chỉ nhập 1 trong 3 trường">
                <Input placeholder="Nhập User ID" />
              </Form.Item>
              <Form.Item name="phone_number" label="Số điện thoại" className="w-60" tooltip="Chỉ nhập 1 trong 3 trường">
                <Input placeholder="Nhập số điện thoại" />
              </Form.Item>
              <Form.Item name="email" label="Email" className="w-60" tooltip="Chỉ nhập 1 trong 3 trường">
                <Input placeholder="Nhập email" />
              </Form.Item>
            </Space>
            <Space>
              <Button type="primary" htmlType="submit" loading={loading}>
                Tra cứu
              </Button>
              <Button
                onClick={() => {
                  form.resetFields();
                  setData(null);
                }}
              >
                Làm mới
              </Button>
            </Space>
          </Space>
        </Form>
      </Card>

      {data && (
        <Card>
          <Space direction="vertical" size="middle" className="w-full">
            <div>
              <Title level={5}>Thông tin người dùng</Title>
              <Descriptions bordered size="small" column={2}>
                <Descriptions.Item label="User ID">{data.user.id}</Descriptions.Item>
                <Descriptions.Item label="Số điện thoại">{data.user.phone_number || "-"}</Descriptions.Item>
                <Descriptions.Item label="Email">{data.user.email || "-"}</Descriptions.Item>
                <Descriptions.Item label="Tên">{data.user.display_name || data.user.fullname || "-"}</Descriptions.Item>
              </Descriptions>
            </div>
            <div>
              <Space direction="vertical" className="w-full">
                <Title level={5}>Danh sách role</Title>
                <Text type="secondary">Hiển thị thời gian hết hạn theo múi giờ hệ thống</Text>
                <Table
                  rowKey={(record) => `${record.role_id}-${record.expired_date || "none"}`}
                  dataSource={data.roles}
                  columns={columns}
                  pagination={false}
                />
              </Space>
            </div>
          </Space>
        </Card>
      )}
    </div>
  );
};

export default RoleLookup;

